
export const GET_ACTIVE_SERVICES_REQUEST = "GET_ACTIVE_SERVICES_REQUEST";
export const GET_ACTIVE_SERVICES_SUCCESS = "GET_ACTIVE_SERVICES_SUCCESS";
export const GET_ACTIVE_SERVICES_FAILURE = "GET_ACTIVE_SERVICES_FAILURE";


export const getActiveServicesRequest = (filters = {}) => ({
    type: GET_ACTIVE_SERVICES_REQUEST,
    payload: {
        filters
    }
});

export const getActiveServicesSuccess = (activeservices, total) => ({
    type: GET_ACTIVE_SERVICES_SUCCESS,
    payload: {
        activeservices,
        total
    }
});

export const getActiveServicesFailure = err => ({
    type: GET_ACTIVE_SERVICES_FAILURE,
    error: err
});

